module.exports = __webpack_public_path__ + "img/lr1.309bb57b.png";